import { render } from "./SplitByBio.vue?vue&type=template&id=3ea121a6&scoped=true&lang=pug"
import script from "./SplitByBio.vue?vue&type=script&lang=js"
export * from "./SplitByBio.vue?vue&type=script&lang=js"

import "./SplitByBio.vue?vue&type=style&index=0&id=3ea121a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea121a6"]])

export default __exports__